import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  InventoryAttributeItemInterface,
  FilterOptionType,
  ProductOptionType,
} from 'features/SupplyOrder/@types/OutboundSKUConfig'
import {
  SLICE_NAME_OUTBOUND_SKU_CONFIG,
  fetchInventoryAttributeList,
  fetchFilterLocations,
  fetchFilterProducts,
  createInventoryAttribute,
  updateInventoryAttribute,
} from './thunk'

export type OutboundSKUConfigInitialStateType = {
  isLoading: boolean
  inventoryAttributeList: InventoryAttributeItemInterface[]
  numberOfElements: number
  constants: {
    locations: FilterOptionType[]
    products: ProductOptionType[]
  }
  isOpenDialogAddProduct: boolean
}

const initialState: OutboundSKUConfigInitialStateType = {
  isLoading: true,
  inventoryAttributeList: [],
  numberOfElements: 0,
  constants: {
    locations: [],
    products: [],
  },
  isOpenDialogAddProduct: false,
}

const slice = createSlice({
  name: SLICE_NAME_OUTBOUND_SKU_CONFIG,
  initialState,
  reducers: {
    resetStateOutboundSKUConfig: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setIsOpenDialogAddProduct: (state, { payload }: PayloadAction<boolean>) => {
      state.isOpenDialogAddProduct = payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<OutboundSKUConfigInitialStateType>) => {
      builder.addCase(fetchInventoryAttributeList.fulfilled, (state, { payload }) => {
        state.inventoryAttributeList = payload.data
        state.numberOfElements = payload.data.length
      })
      builder.addCase(fetchFilterLocations.fulfilled, (state, action) => {
        state.constants.locations = action.payload.map((location) => ({
          id: location.location_id,
          name: location.location_name,
        }))
      })
      builder.addCase(fetchFilterProducts.fulfilled, (state, action) => {
        state.constants.products = action.payload.map((product) => ({
          id: product.product_id,
          name: product.product_name,
          skuNumber: product.product_sku_no,
        }))
      })
    },
    [fetchInventoryAttributeList, createInventoryAttribute, updateInventoryAttribute],
  ),
})

export const { resetStateOutboundSKUConfig, setIsLoading, setIsOpenDialogAddProduct } =
  slice.actions

export default slice.reducer
